/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.com.mu.geologic.proto.GeoDistanceRequest', null, global);
goog.exportSymbol('proto.com.mu.geologic.proto.GeoDistanceResponse', null, global);
goog.exportSymbol('proto.com.mu.geologic.proto.GeocodePositionRequest', null, global);
goog.exportSymbol('proto.com.mu.geologic.proto.GeocodeRequest', null, global);
goog.exportSymbol('proto.com.mu.geologic.proto.GeocodeResponse', null, global);
goog.exportSymbol('proto.com.mu.geologic.proto.Geolocation', null, global);
goog.exportSymbol('proto.com.mu.geologic.proto.ResultType', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.geologic.proto.GeocodeRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.geologic.proto.GeocodeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.geologic.proto.GeocodeRequest.displayName = 'proto.com.mu.geologic.proto.GeocodeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.geologic.proto.GeocodePositionRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.geologic.proto.GeocodePositionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.geologic.proto.GeocodePositionRequest.displayName = 'proto.com.mu.geologic.proto.GeocodePositionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.geologic.proto.GeoDistanceRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.geologic.proto.GeoDistanceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.geologic.proto.GeoDistanceRequest.displayName = 'proto.com.mu.geologic.proto.GeoDistanceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.geologic.proto.Geolocation = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.geologic.proto.Geolocation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.geologic.proto.Geolocation.displayName = 'proto.com.mu.geologic.proto.Geolocation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.geologic.proto.GeocodeResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.geologic.proto.GeocodeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.geologic.proto.GeocodeResponse.displayName = 'proto.com.mu.geologic.proto.GeocodeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.geologic.proto.GeoDistanceResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.geologic.proto.GeoDistanceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.geologic.proto.GeoDistanceResponse.displayName = 'proto.com.mu.geologic.proto.GeoDistanceResponse';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.geologic.proto.GeocodeRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.geologic.proto.GeocodeRequest.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.geologic.proto.GeocodeRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.geologic.proto.GeocodeRequest.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        country: jspb.Message.getFieldWithDefault(msg, 1, ''),
        city: jspb.Message.getFieldWithDefault(msg, 2, ''),
        address: jspb.Message.getFieldWithDefault(msg, 3, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.geologic.proto.GeocodeRequest}
 */
proto.com.mu.geologic.proto.GeocodeRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.geologic.proto.GeocodeRequest();
  return proto.com.mu.geologic.proto.GeocodeRequest.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.geologic.proto.GeocodeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.geologic.proto.GeocodeRequest}
 */
proto.com.mu.geologic.proto.GeocodeRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setCountry(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setCity(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setAddress(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.geologic.proto.GeocodeRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.geologic.proto.GeocodeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.geologic.proto.GeocodeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.geologic.proto.GeocodeRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
};

/**
 * optional string country = 1;
 * @return {string}
 */
proto.com.mu.geologic.proto.GeocodeRequest.prototype.getCountry = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''));
};

/** @param {string} value */
proto.com.mu.geologic.proto.GeocodeRequest.prototype.setCountry = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional string city = 2;
 * @return {string}
 */
proto.com.mu.geologic.proto.GeocodeRequest.prototype.getCity = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/** @param {string} value */
proto.com.mu.geologic.proto.GeocodeRequest.prototype.setCity = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string address = 3;
 * @return {string}
 */
proto.com.mu.geologic.proto.GeocodeRequest.prototype.getAddress = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.com.mu.geologic.proto.GeocodeRequest.prototype.setAddress = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.geologic.proto.GeocodePositionRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.geologic.proto.GeocodePositionRequest.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.geologic.proto.GeocodePositionRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.geologic.proto.GeocodePositionRequest.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        country: jspb.Message.getFieldWithDefault(msg, 1, ''),
        longitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
        latitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.geologic.proto.GeocodePositionRequest}
 */
proto.com.mu.geologic.proto.GeocodePositionRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.geologic.proto.GeocodePositionRequest();
  return proto.com.mu.geologic.proto.GeocodePositionRequest.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.geologic.proto.GeocodePositionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.geologic.proto.GeocodePositionRequest}
 */
proto.com.mu.geologic.proto.GeocodePositionRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setCountry(value);
        break;
      case 2:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setLongitude(value);
        break;
      case 3:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setLatitude(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.geologic.proto.GeocodePositionRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.geologic.proto.GeocodePositionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.geologic.proto.GeocodePositionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.geologic.proto.GeocodePositionRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getLongitude();
  if (f !== 0.0) {
    writer.writeDouble(2, f);
  }
  f = message.getLatitude();
  if (f !== 0.0) {
    writer.writeDouble(3, f);
  }
};

/**
 * optional string country = 1;
 * @return {string}
 */
proto.com.mu.geologic.proto.GeocodePositionRequest.prototype.getCountry = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''));
};

/** @param {string} value */
proto.com.mu.geologic.proto.GeocodePositionRequest.prototype.setCountry = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional double longitude = 2;
 * @return {number}
 */
proto.com.mu.geologic.proto.GeocodePositionRequest.prototype.getLongitude = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};

/** @param {number} value */
proto.com.mu.geologic.proto.GeocodePositionRequest.prototype.setLongitude = function (value) {
  jspb.Message.setProto3FloatField(this, 2, value);
};

/**
 * optional double latitude = 3;
 * @return {number}
 */
proto.com.mu.geologic.proto.GeocodePositionRequest.prototype.getLatitude = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};

/** @param {number} value */
proto.com.mu.geologic.proto.GeocodePositionRequest.prototype.setLatitude = function (value) {
  jspb.Message.setProto3FloatField(this, 3, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.geologic.proto.GeoDistanceRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.geologic.proto.GeoDistanceRequest.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.geologic.proto.GeoDistanceRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.geologic.proto.GeoDistanceRequest.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        country: jspb.Message.getFieldWithDefault(msg, 1, ''),
        originlongitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
        originlatitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
        destinationlongitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
        destinationlatitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.geologic.proto.GeoDistanceRequest}
 */
proto.com.mu.geologic.proto.GeoDistanceRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.geologic.proto.GeoDistanceRequest();
  return proto.com.mu.geologic.proto.GeoDistanceRequest.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.geologic.proto.GeoDistanceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.geologic.proto.GeoDistanceRequest}
 */
proto.com.mu.geologic.proto.GeoDistanceRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setCountry(value);
        break;
      case 2:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setOriginlongitude(value);
        break;
      case 3:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setOriginlatitude(value);
        break;
      case 4:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setDestinationlongitude(value);
        break;
      case 5:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setDestinationlatitude(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.geologic.proto.GeoDistanceRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.geologic.proto.GeoDistanceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.geologic.proto.GeoDistanceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.geologic.proto.GeoDistanceRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getOriginlongitude();
  if (f !== 0.0) {
    writer.writeDouble(2, f);
  }
  f = message.getOriginlatitude();
  if (f !== 0.0) {
    writer.writeDouble(3, f);
  }
  f = message.getDestinationlongitude();
  if (f !== 0.0) {
    writer.writeDouble(4, f);
  }
  f = message.getDestinationlatitude();
  if (f !== 0.0) {
    writer.writeDouble(5, f);
  }
};

/**
 * optional string country = 1;
 * @return {string}
 */
proto.com.mu.geologic.proto.GeoDistanceRequest.prototype.getCountry = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''));
};

/** @param {string} value */
proto.com.mu.geologic.proto.GeoDistanceRequest.prototype.setCountry = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional double originLongitude = 2;
 * @return {number}
 */
proto.com.mu.geologic.proto.GeoDistanceRequest.prototype.getOriginlongitude = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};

/** @param {number} value */
proto.com.mu.geologic.proto.GeoDistanceRequest.prototype.setOriginlongitude = function (value) {
  jspb.Message.setProto3FloatField(this, 2, value);
};

/**
 * optional double originLatitude = 3;
 * @return {number}
 */
proto.com.mu.geologic.proto.GeoDistanceRequest.prototype.getOriginlatitude = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};

/** @param {number} value */
proto.com.mu.geologic.proto.GeoDistanceRequest.prototype.setOriginlatitude = function (value) {
  jspb.Message.setProto3FloatField(this, 3, value);
};

/**
 * optional double destinationLongitude = 4;
 * @return {number}
 */
proto.com.mu.geologic.proto.GeoDistanceRequest.prototype.getDestinationlongitude = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};

/** @param {number} value */
proto.com.mu.geologic.proto.GeoDistanceRequest.prototype.setDestinationlongitude = function (value) {
  jspb.Message.setProto3FloatField(this, 4, value);
};

/**
 * optional double destinationLatitude = 5;
 * @return {number}
 */
proto.com.mu.geologic.proto.GeoDistanceRequest.prototype.getDestinationlatitude = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};

/** @param {number} value */
proto.com.mu.geologic.proto.GeoDistanceRequest.prototype.setDestinationlatitude = function (value) {
  jspb.Message.setProto3FloatField(this, 5, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.geologic.proto.Geolocation.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.geologic.proto.Geolocation.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.geologic.proto.Geolocation} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.geologic.proto.Geolocation.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        lat: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
        lng: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.geologic.proto.Geolocation}
 */
proto.com.mu.geologic.proto.Geolocation.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.geologic.proto.Geolocation();
  return proto.com.mu.geologic.proto.Geolocation.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.geologic.proto.Geolocation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.geologic.proto.Geolocation}
 */
proto.com.mu.geologic.proto.Geolocation.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setLat(value);
        break;
      case 2:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setLng(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.geologic.proto.Geolocation.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.geologic.proto.Geolocation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.geologic.proto.Geolocation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.geologic.proto.Geolocation.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getLat();
  if (f !== 0.0) {
    writer.writeDouble(1, f);
  }
  f = message.getLng();
  if (f !== 0.0) {
    writer.writeDouble(2, f);
  }
};

/**
 * optional double lat = 1;
 * @return {number}
 */
proto.com.mu.geologic.proto.Geolocation.prototype.getLat = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};

/** @param {number} value */
proto.com.mu.geologic.proto.Geolocation.prototype.setLat = function (value) {
  jspb.Message.setProto3FloatField(this, 1, value);
};

/**
 * optional double lng = 2;
 * @return {number}
 */
proto.com.mu.geologic.proto.Geolocation.prototype.getLng = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};

/** @param {number} value */
proto.com.mu.geologic.proto.Geolocation.prototype.setLng = function (value) {
  jspb.Message.setProto3FloatField(this, 2, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.geologic.proto.GeocodeResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.geologic.proto.GeocodeResponse.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.geologic.proto.GeocodeResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.geologic.proto.GeocodeResponse.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        country: jspb.Message.getFieldWithDefault(msg, 1, ''),
        state: jspb.Message.getFieldWithDefault(msg, 2, ''),
        city: jspb.Message.getFieldWithDefault(msg, 3, ''),
        locality: jspb.Message.getFieldWithDefault(msg, 4, ''),
        neighborhood: jspb.Message.getFieldWithDefault(msg, 5, ''),
        address: jspb.Message.getFieldWithDefault(msg, 6, ''),
        postalcode: jspb.Message.getFieldWithDefault(msg, 7, ''),
        location: (f = msg.getLocation()) && proto.com.mu.geologic.proto.Geolocation.toObject(includeInstance, f),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.geologic.proto.GeocodeResponse}
 */
proto.com.mu.geologic.proto.GeocodeResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.geologic.proto.GeocodeResponse();
  return proto.com.mu.geologic.proto.GeocodeResponse.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.geologic.proto.GeocodeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.geologic.proto.GeocodeResponse}
 */
proto.com.mu.geologic.proto.GeocodeResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setCountry(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setState(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setCity(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setLocality(value);
        break;
      case 5:
        var value = /** @type {string} */ (reader.readString());
        msg.setNeighborhood(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setAddress(value);
        break;
      case 7:
        var value = /** @type {string} */ (reader.readString());
        msg.setPostalcode(value);
        break;
      case 8:
        var value = new proto.com.mu.geologic.proto.Geolocation();
        reader.readMessage(value, proto.com.mu.geologic.proto.Geolocation.deserializeBinaryFromReader);
        msg.setLocation(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.geologic.proto.GeocodeResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.geologic.proto.GeocodeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.geologic.proto.GeocodeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.geologic.proto.GeocodeResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getState();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getLocality();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getNeighborhood();
  if (f.length > 0) {
    writer.writeString(5, f);
  }
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
  f = message.getPostalcode();
  if (f.length > 0) {
    writer.writeString(7, f);
  }
  f = message.getLocation();
  if (f != null) {
    writer.writeMessage(8, f, proto.com.mu.geologic.proto.Geolocation.serializeBinaryToWriter);
  }
};

/**
 * optional string country = 1;
 * @return {string}
 */
proto.com.mu.geologic.proto.GeocodeResponse.prototype.getCountry = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''));
};

/** @param {string} value */
proto.com.mu.geologic.proto.GeocodeResponse.prototype.setCountry = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional string state = 2;
 * @return {string}
 */
proto.com.mu.geologic.proto.GeocodeResponse.prototype.getState = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/** @param {string} value */
proto.com.mu.geologic.proto.GeocodeResponse.prototype.setState = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string city = 3;
 * @return {string}
 */
proto.com.mu.geologic.proto.GeocodeResponse.prototype.getCity = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.com.mu.geologic.proto.GeocodeResponse.prototype.setCity = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional string locality = 4;
 * @return {string}
 */
proto.com.mu.geologic.proto.GeocodeResponse.prototype.getLocality = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/** @param {string} value */
proto.com.mu.geologic.proto.GeocodeResponse.prototype.setLocality = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional string neighborhood = 5;
 * @return {string}
 */
proto.com.mu.geologic.proto.GeocodeResponse.prototype.getNeighborhood = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''));
};

/** @param {string} value */
proto.com.mu.geologic.proto.GeocodeResponse.prototype.setNeighborhood = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};

/**
 * optional string address = 6;
 * @return {string}
 */
proto.com.mu.geologic.proto.GeocodeResponse.prototype.getAddress = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''));
};

/** @param {string} value */
proto.com.mu.geologic.proto.GeocodeResponse.prototype.setAddress = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};

/**
 * optional string postalCode = 7;
 * @return {string}
 */
proto.com.mu.geologic.proto.GeocodeResponse.prototype.getPostalcode = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ''));
};

/** @param {string} value */
proto.com.mu.geologic.proto.GeocodeResponse.prototype.setPostalcode = function (value) {
  jspb.Message.setProto3StringField(this, 7, value);
};

/**
 * optional Geolocation location = 8;
 * @return {?proto.com.mu.geologic.proto.Geolocation}
 */
proto.com.mu.geologic.proto.GeocodeResponse.prototype.getLocation = function () {
  return /** @type{?proto.com.mu.geologic.proto.Geolocation} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.geologic.proto.Geolocation, 8)
  );
};

/** @param {?proto.com.mu.geologic.proto.Geolocation|undefined} value */
proto.com.mu.geologic.proto.GeocodeResponse.prototype.setLocation = function (value) {
  jspb.Message.setWrapperField(this, 8, value);
};

/**
 * Clears the message field making it undefined.
 */
proto.com.mu.geologic.proto.GeocodeResponse.prototype.clearLocation = function () {
  this.setLocation(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.geologic.proto.GeocodeResponse.prototype.hasLocation = function () {
  return jspb.Message.getField(this, 8) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.geologic.proto.GeoDistanceResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.geologic.proto.GeoDistanceResponse.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.geologic.proto.GeoDistanceResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.geologic.proto.GeoDistanceResponse.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        duration: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
        distance: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.geologic.proto.GeoDistanceResponse}
 */
proto.com.mu.geologic.proto.GeoDistanceResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.geologic.proto.GeoDistanceResponse();
  return proto.com.mu.geologic.proto.GeoDistanceResponse.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.geologic.proto.GeoDistanceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.geologic.proto.GeoDistanceResponse}
 */
proto.com.mu.geologic.proto.GeoDistanceResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setDuration(value);
        break;
      case 2:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setDistance(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.geologic.proto.GeoDistanceResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.geologic.proto.GeoDistanceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.geologic.proto.GeoDistanceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.geologic.proto.GeoDistanceResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getDuration();
  if (f !== 0.0) {
    writer.writeDouble(1, f);
  }
  f = message.getDistance();
  if (f !== 0.0) {
    writer.writeDouble(2, f);
  }
};

/**
 * optional double duration = 1;
 * @return {number}
 */
proto.com.mu.geologic.proto.GeoDistanceResponse.prototype.getDuration = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};

/** @param {number} value */
proto.com.mu.geologic.proto.GeoDistanceResponse.prototype.setDuration = function (value) {
  jspb.Message.setProto3FloatField(this, 1, value);
};

/**
 * optional double distance = 2;
 * @return {number}
 */
proto.com.mu.geologic.proto.GeoDistanceResponse.prototype.getDistance = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};

/** @param {number} value */
proto.com.mu.geologic.proto.GeoDistanceResponse.prototype.setDistance = function (value) {
  jspb.Message.setProto3FloatField(this, 2, value);
};

/**
 * @enum {number}
 */
proto.com.mu.geologic.proto.ResultType = {
  NOT_FOUND: 0,
  FOUND: 1,
  PARTIAL_MATCH: 2,
};

goog.object.extend(exports, proto.com.mu.geologic.proto);
